import { kea } from "kea";

import api from '../utils/api';

import userlogic from "./user";
import alertlogic from "./alert";
import vehiclelogic from "./vehicle";
import geofencelogic from "./geofence";
import assetlogic from "./asset";

export const grouplogic = kea({
	actions: {
		create: (group) => ({ group }),
		fetchAll: true,
		add_users: (group) => ({ group }),
		add_vehicles: (group) => ({ group }),
		add_assets: (group) => ({ group }),
		add_alerts: (group) => ({ group }),
		add_geofences: (group) => ({ group }),
		remove_users: (group) => ({ group }),
		remove_vehicles: (group) => ({ group }),
		remove_assets: (group) => ({ group }),
		remove_alerts: (group) => ({ group }),
		remove_geofences: (group) => ({ group }),
		updateName: (group) => ({ group }),
		remove: (group) => ({ group }),

		setAll: (groups) => ({ groups }),
		setOne: (group) => ({ group }),
		addOne: (group) => ({ group }),
		removeOne: (group) => ({ group }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		groups: [null, {
			setAll: (_, { groups }) => groups,
			setOne: (state, { group }) => state.map((s) => s._id === group._id ? group : s),
			addOne: (state, { group }) => [...state, group],
			removeOne: (state, { group }) => state.filter((s) => group._id !== s._id),
		}],
		loading: [false, {
			create: () => true,
			fetchAll: () => true,
			add_users: () => true,
			add_vehicles: () => true,
			add_assets: () => true,
			add_alerts: () => true,
			add_geofences: () => true,
			remove_users: () => true,
			remove_vehicles: () => true,
			remove_assets: () => true,
			remove_alerts: () => true,
			remove_geofences: () => true,
			updateName: () => true,
			remove: () => true,

			setAll: () => false,
			setOne: () => false,
			addOne: () => false,
			removeOne: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			setAll: () => null,
			setOne: () => null,
			addOne: () => null,
			removeOne: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		create: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = '/group';
			let res;
			try {
				res = await api({ url, method: 'post', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.addOne(json.payload);
				actions.setSuccess('Group Created.');
			}
			else actions.setError(json.error);
		},
		fetchAll: async (_, breakpoint) => {
			await breakpoint(300)
			let url = '/group';
			let res;
			try {
				res = await api({ url });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.setAll(json.payload);
			else actions.setError(json.error);
		},
		add_users: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/users`;
			let res;
			try {
				res = await api({ url, method: 'put', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				userlogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		add_vehicles: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/vehicles`;
			let res;
			try {
				res = await api({ url, method: 'put', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				vehiclelogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		add_assets: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/assets`;
			let res;
			try {
				res = await api({ url, method: 'put', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				assetlogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		add_alerts: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/alerts`;
			let res;
			try {
				res = await api({ url, method: 'put', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				alertlogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		add_geofences: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/geofences`;
			let res;
			try {
				res = await api({ url, method: 'put', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				geofencelogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		remove_users: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/users`;
			let res;
			try {
				res = await api({ url, method: 'delete', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				userlogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		remove_vehicles: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/vehicles`;
			let res;
			try {
				res = await api({ url, method: 'delete', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				vehiclelogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		remove_assets: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/assets`;
			let res;
			try {
				res = await api({ url, method: 'delete', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				assetlogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		remove_alerts: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/alerts`;
			let res;
			try {
				res = await api({ url, method: 'delete', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				alertlogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		remove_geofences: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/geofences`;
			let res;
			try {
				res = await api({ url, method: 'delete', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				geofencelogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		updateName: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}/name`;
			let res;
			try {
				res = await api({ url, method: 'put', body: group });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				userlogic.actions.fetchAll();
				alertlogic.actions.fetchAll();
				vehiclelogic.actions.fetchAll();
				geofencelogic.actions.fetchAll();
				assetlogic.actions.fetchAll();
				actions.setSuccess('Group Updated.');
			} else actions.setError(json.error);
		},
		remove: async ({ group }, breakpoint) => {
			await breakpoint(300);
			let url = `/group/${group._id}`;
			let res;
			try {
				res = await api({ url, method: 'delete' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.removeOne(group);
				userlogic.actions.fetchAll();
				alertlogic.actions.fetchAll();
				vehiclelogic.actions.fetchAll();
				geofencelogic.actions.fetchAll();
				assetlogic.actions.fetchAll();
				actions.setSuccess('Group Removed.');
			} else actions.setError(json.error);
		}
	})
});

export default grouplogic;